import server from "./server";

export const getUnitsApi = async () => {
  const response = await server().get("/measurementUnits");
  return response.data;
};
